var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.29743 1.63224L10.6174 4.27224C10.7974 4.63974 11.2774 4.99224 11.6824 5.05974L14.0749 5.45724C15.6049 5.71224 15.9649 6.82224 14.8624 7.91724L13.0024 9.77724C12.6874 10.0922 12.5149 10.6997 12.6124 11.1347L13.1449 13.4372C13.5649 15.2597 12.5974 15.9647 10.9849 15.0122L8.74243 13.6847C8.33743 13.4447 7.66993 13.4447 7.25743 13.6847L5.01493 15.0122C3.40993 15.9647 2.43493 15.2522 2.85493 13.4372L3.38743 11.1347C3.48493 10.6997 3.31243 10.0922 2.99743 9.77724L1.13743 7.91724C0.0424318 6.82224 0.394932 5.71224 1.92493 5.45724L4.31743 5.05974C4.71493 4.99224 5.19493 4.63974 5.37493 4.27224L6.69493 1.63224C7.41493 0.199736 8.58493 0.199736 9.29743 1.63224Z",
    fill: "#FBFBFB",
    stroke: "#FF8C21",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.9f5d4667c169cd90c0ab263d94dadb81.svg";
export { ForwardRef as ReactComponent };